import { Button } from "@miror-ui/components";
import { Logo } from "shared/components/atoms/Logo";
import { CloseButtonIcon } from "shared/assets/icons/CloseButtonIcon";
import { IconButton } from "shared/components/atoms/IconButton";
import { useState } from "react";
import tw from "twin.macro";
import { useRouter } from "next/router";
import { Paths } from "utils/routes";

export const OverlayBanner = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { push } = useRouter();

  const handleCloseButton = () => {
    setIsOpen(false);
  };

  const handleTransitionButton = () => {
    push({
      pathname: Paths.subscription.plans(9).無料占い,
      query: {
        utm_source: "media",
        utm_medium: "referral",
        utm_campaign: "mediawebLINE",
        clid: "iB9Fflj7UN0HyQrPSxDOXg",
        action: "line",
        isSubscription: true,
        id: 9,
      },
    });
  };

  return (
    <div
      tw="fixed z-10 bottom-4 px-6 w-full max-w-[640px]"
      css={[isOpen ? tw`block` : tw`hidden`]}
    >
      <div tw="bg-gradient-to-l from-[#B647B7] to-[#F683B6] px-4 py-4 rounded-[13px] shadow-lg relative">
        <IconButton
          onClick={handleCloseButton}
          icon={<CloseButtonIcon tw="absolute top-[-10px] right-[-10px]" />}
        />
        <div tw="flex flex-row">
          <div tw="flex-col">
            <p tw="text-white text-[9px] font-semibold mb-2">
              いまだけ無料で本格タロット鑑定❤
            </p>
            <p tw="text-white text-[15px] font-semibold">
              彼の気持ちや復縁可能性、
              <br />
              恋愛に関する悩みを占おう！
            </p>
          </div>
          <div tw="flex flex-col relative ">
            <Logo
              color="white"
              disabled
              tw="w-[42px] h-[10px] mb-[11px] fixed right-10"
            />
            <Button
              onClick={handleTransitionButton}
              variant="outlined"
              tw="bg-white text-theme h-[35px] py-[11px] px-[10px] ml-[7px] mt-6"
            >
              無料で占う
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
